<template>
  <div class="upload">
    <h2 class="upload-title">{{ title }}</h2>
    <div class="upload-wrapper"
    @drop.prevent="onDrop"
    @dragover.prevent="onDragover"
    @dragleave.prevent="dragover = false">
      <div v-if="!fileList.length"
           class="upload-add">
        <div class="upload--add-image">
          <slot name="image"></slot>
        </div>
        <button class="clear_button_default_mixins upload-add-btn"
                @click="handleChoseFile">
          点击上传文件
        </button>
        <h2 class="upload-add-subtitle">
          <slot name="des"></slot>
        </h2>
      </div>
      <div v-else
           class="upload-convert">
        <div class="upload-convert-content">
          <div class="upload-convert-file">
            <!-- 转换完成 -->
            <template v-if="isConvertComplete">
              <img
                 src="../../../assets/icon/convert/icon_selected.png"
                 class="upload-convert-complete" alt="">
              <slot name="complete-image" :extension="extension"></slot>
              <a class="upload-convert-preview" :href="fileUrl" download @click="handleDownLoad">下载</a>
              <p class="upload-convert-file-name">{{ fileName }}.{{ extension }}</p>
            </template>
            <!-- 未转换完成 -->
            <template v-else>
              <slot name="image"></slot>
              <p class="upload-convert-file-name">{{ fileList[0].name }}</p>
            </template>
            <!-- 转换前 -->
            <img v-if="!isConverting && !isConvertComplete"
                 class="upload-convert-file-close"
                 src="../../../assets/icon/convert/icon_error.png"
                 alt=""
                 @click="handleClose">
          </div>
          <div class="upload-convert-replace" @click="handleChoseFile">
            <div class="upload-convert-replace-wrapper"></div>
            <button :class="{'upload-convert-replace-btn-disabled': isConverting}"
                    class="upload-convert-replace-btn">
              替换文件
            </button>
          </div>
        </div>
        <div class="upload-convert-des">
          <Progress v-if="isConverting" :percentage="convertPercentage"></Progress>
          {{ filesInfo }}
          <!-- 转换完成 -->
          <template v-if="isConvertComplete">
            <span class="upload-convert-des-tips">您的文件已转换完成，请点击上方下载按钮进行下载！</span>
            <button class="upload-convert-btn" @click="handleChoseFile">
             继续添加
            </button>
          </template>
          <!-- 未转换完成 -->
          <button v-else class="upload-convert-btn"
                  :class="{'upload-convert-btn-disabled': isConverting}"
                  :disabled="isConverting"
                  @click="handleConvert">
             {{ isConverting ? '转换中' : '开始转换' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fileToMD5, getFileType, getPageByRouter } from '@/utils'
import { showToast } from '@/components/toast'
import { apiPdfConvert, apiPdfStartConvert, apiPdfReportUpload, apiPdfQueryProgress } from '@/api'
import { clientVipDialog, clientReport } from '@/client'
import { PDF_TABLE, PDF_PAGE, PAGE_ACTION } from '@/client/constant'
import Progress from './Progress'

const COS = require('cos-js-sdk-v5')
export default {
  name: 'Upload',
  components: {
    Progress
  },
  data () {
    return {
      isConverting: false,
      isConvertComplete: false,
      fileUrl: '',
      dragover: false,
      convertPercentage: 0,
      extension: '', // 要转换成的target扩展名
      openFrom: 0,
      page: 0
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    des: {
      type: {
        type: String,
        required: true
      }
    },
    cmd: {
      type: String,
      required: true
    },
    convertPrams: {
      type: Object,
      required: true
    },
    // 校验文件类型
    validFileType: {
      type: Function,
      required: false,
      default: function () {
        return true
      }
    },
    // 校验文件大小
    validFileSize: {
      type: Function,
      required: false,
      default: function () {
        return true
      }
    },
    validFile: {
      type: Function,
      required: false,
      default: function () {
        return true
      }
    },
    fileList: {
      type: Array,
      required: true
    },
    accept: {
      type: String
    }
  },
  computed: {
    ...mapGetters([
      'isVip',
      'isLogin'
    ]),
    size () {
      return this.fileList.reduce((first, second) => {
        return first + second.size
      }, 0)
    },
    filesInfo () {
      const fileSize = (this.size / 1024 / 1024).toFixed(3)
      return `共${this.fileList.length}个文档，${fileSize}M`
    },
    fileName () {
      if (this.fileList.length > 0) {
        // 去除扩展名的文件名
        return this.fileList[0].name.split('.')[0]
      }
      return ''
    }
  },
  mounted () {
    this.openFrom = this.getOpenFrom()
    this.page = this.getPage()
  },
  methods: {
    /**
     * @description 选择文件
     */
    handleChoseFile () {
      if (this.isConverting) {
        return
      }
      // REPORT 点击上传文件触发埋点上报
      clientReport(PDF_TABLE, {
        source: this.openFrom,
        page_show: this.page,
        click: PAGE_ACTION.UPLOAD
      })
      if (!this.isLogin) {
        this.$store.commit('openLoginWindow')
        // REPORT 点击上传文件触发用户登录卡点上报
        clientReport(PDF_TABLE, {
          source: this.openFrom,
          page_show: PDF_PAGE.LOGIN_DIALOG,
          click: PAGE_ACTION.DEFAULT
        })
        return
      }
      if (!this.isVip) {
        clientVipDialog()
        // REPORT 点击上传文件触发VIP卡点上报
        clientReport(PDF_TABLE, {
          source: this.openFrom,
          page_show: PDF_PAGE.VIP_DIALOG,
          click: PAGE_ACTION.DEFAULT
        })
        return
      }
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      if (this.accept && typeof this.accept === 'string') {
        input.setAttribute('accept', this.accept)
      }
      const inputChange = (event) => {
        if (!event.path ||
          !event.path.length ||
          !event.path[0].files ||
          !event.path[0].files.length) {
          removerEventListener()
          return
        }
        const file = event.target.files[0]
        if (!this.validFileType(file.name) || !this.validFileSize(file.size) || !this.validFile(file)) {
          removerEventListener()
          return
        }
        this.isConverting = false
        this.isConvertComplete = false
        this.convertPercentage = 0
        this.fileList.splice(0, 1)
        this.fileList.push(file)
      }
      const removerEventListener = () => {
        input.removeEventListener('change', inputChange)
      }
      input.addEventListener('change', inputChange)
      input.click()
    },
    /**
     * @description 开始转换
     */
    // eslint-disable-next-line sonarjs/cognitive-complexity
    async handleConvert () {
      // REPORT 点击开始转换触发埋点上报
      clientReport(PDF_TABLE, {
        source: this.openFrom,
        page_show: this.page,
        click: PAGE_ACTION.CONVERT
      })
      // 记录本次转换的目标文件拓展名(默认是pdf)
      this.extension = this.convertPrams.target_type || 'pdf'
      this.isConverting = true
      // 开启模拟进度条
      const timeid = this.startProgress()
      try {
        // 计算所有文件的MMD5
        for (let index = 0; index < this.fileList.length; ++index) {
          // 计算获取文件的MD5
          const md5 = await fileToMD5(this.fileList[index])
          this.$emit('compute-md5', index, md5)
        }
        // 请求转换， 获取上传腾讯云的 token secret_id secret_key region bucket  expire_ts slice_size chunk_size
        const authResponse = await apiPdfConvert({
          cmd: this.cmd,
          files: this.fileList.map((file, index) => {
            return {
              md5: this.convertPrams.file_params[index].md5,
              filename: file.name,
              file_type: getFileType(file.name),
              file_length: file.size
            }
          }),
          custom_data: this.convertPrams,
        })

        // 执行cos 认证
        // eslint-disable-next-line camelcase
        const { cos_temp_token, files } = authResponse
        if (!files[0].exist) {
          const cos = new COS({
            getAuthorization: function (options, callback) {
              // eslint-disable-next-line standard/no-callback-literal
              callback({
                TmpSecretId: cos_temp_token.secret_id,
                TmpSecretKey: cos_temp_token.secret_key,
                XCosSecurityToken: cos_temp_token.token,
                StartTime: cos_temp_token.start_ts, // 时间戳，单位秒，如：1580000000
                ExpiredTime: cos_temp_token.expire_ts // 时间戳，单位秒，如：1580000900
              })
            }
          })
          if (!cos) {
            throw new Error('获取COS失败')
          }
          /* uploadResponse 返回数据
          statusCode: 200
          headers: {content-length: "0", etag: ""ae1a381fdb2c95b26239bd04b12c6231"", x-cos-request-id: "NjA0MGM4Y2RfYzZjODJhMDlfMjZhOTVfNmY1MGE1YQ=="}
          Location: "scanner-jiguang-test-1252921383.cos.ap-beijing.myqcloud.com/test_src/3301619282431/ae1a381fdb2c95b26239bd04b12c6231.pdf"
          ETag: ""ae1a381fdb2c95b26239bd04b12c6231""
          RequestId: "NjA0MGM4Y2RfYzZjODJhMDlfMjZhOTVfNmY1MGE1YQ=="
          */
          const uploadResponse = await new Promise((resolve, reject) => {
            cos.putObject({
              Bucket: cos_temp_token.bucket,
              Region: cos_temp_token.region,
              Key: files[0].cos_path,
              StorageClass: 'STANDARD',
              Body: this.fileList[0] // a上传文件对象
            }, function (err, data) {
              if (err) {
                reject(err)
              } else {
                resolve(data)
              }
            })
          })
        }
        const reportResponse = await apiPdfReportUpload({
          req_id: Number.parseInt(authResponse.req_id),
          md5: this.convertPrams.file_params[0].md5,
          status: 1
        })

        const convertResponse = await apiPdfStartConvert({
          req_id: Number.parseInt(authResponse.req_id),
          file_md5_list: [
            this.convertPrams.file_params[0].md5
          ]
        })
        const response = await new Promise((resolve, reject) => {
          const interval = () => {
            apiPdfQueryProgress({
              req_id_list: [Number.parseInt(authResponse.req_id)]
            }).then((response) => {
              if (response.convert_list && response.convert_list.length) {
                if (response.convert_list[0].status === 4) {
                  resolve(response)
                } else {
                  window.setTimeout(() => {
                    interval()
                  }, response.retry_interval * 1000)
                }
              } else {
                window.setTimeout(() => {
                  interval()
                }, response.retry_interval * 1000)
              }
            }).catch((error) => {
              reject(error)
            })
          }
          interval()
        })
        this.fileUrl = response.convert_list[0].result_files[0].url
        this.isConverting = false
        this.isConvertComplete = true
        // 完成转换
        this.convertPercentage = 100
        clearInterval(timeid)
      } catch (e) {
        console.warn(e)
        this.isConverting = false
        clearInterval(timeid)
      }
    },
    handleClose () {
      if (this.isConverting) {
        return
      }
      const length = this.fileList.length
      for (let index = 0; index < length; ++index) {
        this.fileList.splice(0, 1)
      }
    },
    /**
     * 拖拽事件
     * @param {DragEvent} e
     */
    onDrop (e) {
      if (this.isConverting) {
        return
      }
      // REPORT 拖拽文件触发埋点上报
      clientReport(PDF_TABLE, {
        source: this.openFrom,
        page_show: this.page,
        click: PAGE_ACTION.DRAG
      })
      if (!this.isLogin) {
        this.$store.commit('openLoginWindow')
        // REPORT 拖拽文件触发用户登录卡点上报
        clientReport(PDF_TABLE, {
          source: this.openFrom,
          page_show: PDF_PAGE.LOGIN_DIALOG,
          click: PAGE_ACTION.DEFAULT
        })
        return
      }
      if (!this.isVip) {
        clientVipDialog()
        // REPORT 拖拽文件触发VIP卡点上报
        clientReport(PDF_TABLE, {
          source: this.openFrom,
          page_show: PDF_PAGE.VIP_DIALOG,
          click: PAGE_ACTION.DEFAULT
        })
        return
      }
      const files = Array.from(e.dataTransfer.files)
      this.handleDroFiles(files)
    },
    onDragover () {
      this.dragover = true
    },
    /**
     * 处理拖拽文件
     * @param {File[]} files
     */
    handleDroFiles (files) {
      if (files.length > 1) {
        showToast('每次只能转换一个文件', 2000)
      } else if (files.length === 1) {
        if (!this.accept) {
          // 上传文件没有类型限制
          this.fileList = files
        } else {
          const { name } = files[0]
          const extension =
             name.indexOf('.') > -1 ? `.${name.split('.').pop().toLowerCase()}` : ''
          // 拖拽文件是否属于上传文件类型
          const isAccept = this.accept
            .split(',')
            .map(type => type.trim())
            .filter(type => type)
            .some(acceptedType => {
            // TODO: 只做了简单的上传文件类型匹配规则
              if (acceptedType.startsWith('.')) {
                return extension === acceptedType
              }
              return false
            })

          const changeUploadFile = () => {
            this.isConverting = false
            this.isConvertComplete = false
            this.convertPercentage = 0
            this.fileList.splice(0, 1)
            this.fileList.push(files[0])
          }
          isAccept ? changeUploadFile() : showToast('请选择符合类型的文件', 2000)
        }
      }
    },
    startProgress () {
      this.convertPercentage = 0
      const timeid = setInterval(() => {
        if (this.convertPercentage < 60) {
          const i = Math.floor(Math.random() * 10)
          this.convertPercentage = this.convertPercentage + i
        } else if (this.convertPercentage < 90) {
          const i = Math.floor(Math.random() * 3 - 1) + 1
          this.convertPercentage = this.convertPercentage + i
        } else {
          clearInterval(timeid)
        }
      }, 500)
      return timeid
    },
    /**
     * 获取打开来源
     */
    getOpenFrom () {
      const params = (new URL(document.location)).searchParams
      const openFrom = params.get('from') ? parseInt(params.get('from')) : 0
      return openFrom
    },
    /**
     * 获取当前页
     */
    getPage () {
      const router = this.$route.path.split('/').pop()
      return getPageByRouter(router)
    },
    handleDownLoad () {
      // REPORT 点击下载按钮触发埋点上报
      clientReport(PDF_TABLE, {
        source: this.openFrom,
        page_show: this.page,
        click: PAGE_ACTION.DOWNLOAD
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/style/styleMixins";
@import "../../../assets/style/styleVariable";

.upload {
  &-title {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    .flex_align_center_mixins;
    margin-bottom: 30px;

    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 20px;
      background: #548EF8;
      margin-right: 12px;
    }
  }

  &-wrapper {
    border: 2px dashed rgba(103, 155, 249, 0.3);
    height: 300px;
    border-radius: 4px;
    transition: border-color .3s;

    &:hover {
      border: 2px dashed rgba(103, 155, 249, 1);
    }
  }

  &-add {
    height: 100%;
    width: 100%;
    .flex_center_mixins;
    flex-direction: column;

    &-image {
      width: 119px;
      height: 116px;

      > img {
        height: 100%;
        width: 100%;
      }
    }

    &-btn {
      background: #548EF8;
      border-radius: 4px;
      padding: 13px 46px;
      border-width: 0;
      font-size: 18px;
      color: #FFFFFF;
      margin-top: 20px;
    }

    &-subtitle {
      font-size: 18px;
      color: #999999;
      margin-top: 20px;
    }
  }

  &-convert {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    &-content {
      flex: 1;
      .flex_center_mixins;
    }
    &-file{
      height: 208px;
      width: 180px;
      .flex_center_mixins;
      flex-direction: column;
      justify-content: space-around;
      margin-right: 20px;
      background: #F9F9F9;
      position: relative;
      &-name{
        width: 160px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-size: 16px;
        color: #666666;
        line-height: 22px;
        text-align: center;
      }
      &-close{
        position: absolute;
        right: -5px;
        top: -5px;
        cursor: pointer;
      }
    }
    &-complete{
      position: absolute;
      left: 0;
      top: 0;
    }
    &-preview{
      display: inline-block;
      background: #548EF8;
      border-radius: 14px;
      padding: 8px 10px;
      color: white;
      cursor: pointer;
      font-size: 14px;
    }
    &-download{
      position: absolute;
      right: 0;
      bottom: 40px;
      display: inline-block;
      background: #548EF8;
      border-radius: 14px;
      padding: 8px 10px;
      color: white;
      cursor: pointer;
    }
    &-replace{
      height: 208px;
      width: 180px;
      .flex_center_mixins;
      flex-direction: column;
      justify-content: space-between;
      &-wrapper{
        height:167px;
        width: 100%;
        box-sizing: border-box;
        border: 2px dashed rgb(103, 155, 249);
        opacity: 0.3;
        .flex_center_mixins;
        &::before{
          content: '';
          display: block;
          position: absolute;
          height: 4px;
          width: 60px;
          background: #ddd;
        }
        &::after{
          content: '';
          display: block;
          position: absolute;
          height: 60px;
          width: 4px;
          background: #ddd;
        }
        &:hover{
          border: 2px dashed rgb(103, 155, 249);
        }
      }
      &-btn{
        .clear_button_default_mixins;
        cursor: pointer;
        background: #548EF8;
        width: 100%;
        border-radius: 4px;
        font-size: 14px;
        color: #FFFFFF;
        padding: 8px;
        border-width: 0;
        &-disabled{
          background: #999999;
          color: white;
          cursor: not-allowed;
        }
      }
    }
    &-des {
      height: 60px;
      .flex_align_center_mixins;
      padding: 0 30px;
      background: #F9F9F9;
      font-size: 16px;
      color: #999999;
      border-width: 0;
      &-tips {
        color: #E6403D;
        margin-left: 30px;
      }
    }

    &-btn {
      .clear_button_default_mixins;
      cursor: pointer;
      border: 1px solid #548EF8;
      padding: 11px 34px;
      background-color: #548EF8;
      color: white;
      border-radius: 4px;
      margin-left: auto;
      &-disabled{
        background: #999999;
        color: white;
        cursor: not-allowed;
      }
    }
  }
}
</style>
